
export class KPIParameter
{
    setParameters(userId: any, startDate: Date, companyId: any, kpiParameterId: any = null, personId: any = null, customerId: any = null, stateProvince: String = null)
    {
        this.userId = userId;
        this.startDate = startDate;
        this.companyId = companyId;
        if (kpiParameterId !== null) {
            this.kpiParameterId = kpiParameterId;
        }
        if (personId !== null) {
            this.personId = personId;
        }
        if (customerId !== null) {
            this.customerId = customerId;
        }
        if (stateProvince !== null) {
            this.stateProvince = stateProvince;
        }
    }
     kpiParameterId: any ;
     startDate: Date ;
     endDate: Date ;
     companyId: any ;
     userId: any ;
     personId: any ;
     customerId: any ;
     stateProvince: String;
}
